<template>
  <v-card>
    <v-toolbar light>
      <v-btn icon light @click="closeView">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        Surat {{ idJenisForm == 1 ? 'Masuk' : 'Keluar' }} -
        {{ item.index_surat_tu }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="idJenisForm == 1 && $store.state.user.target_disposisi.length > 0"
        rounded
        color="primary"
        @click="$emit('disposisi', item)"
      >
        <v-icon left class="hidden-sm-and-down">
          mdi-send
        </v-icon>
        Buat Disposisi
      </v-btn>
    </v-toolbar>
    <v-card-text class="mt-2" style="height: 90vh">
      <v-container grid-list-xl class="pt-10" style="height: 100%">
        <v-layout row justify-center style="height: 100%">
          <v-flex
            v-if="idJenisForm == 1"
            xs4
            md4
            lg4
            xl4
            class="view-surat-left"
          >
            <v-layout column>
              <v-layout row>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.tgl_masuk"
                    label="TANGGAL MASUK"
                    style="border-style: none"
                  />
                </v-flex>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.index_surat_tu"
                    label="INDEX SURAT TU"
                  />
                </v-flex>
              </v-layout>
              <v-text-field readonly v-model="item.no" label="NOMOR SURAT" />
              <v-text-field
                readonly
                label="PENGIRIM"
                rows="2"
                no-resize
                v-model="item.pengirim"
              />
              <v-textarea
                readonly
                label="PERIHAL"
                rows="2"
                no-resize
                v-model="item.perihal"
              />
              <v-text-field
                readonly
                v-model="item.tgl_surat"
                label="TANGGAL SURAT"
              />
              <v-textarea
                readonly
                label="RINGKASAN"
                placeholder="-"
                rows="2"
                no-resize
                v-model="item.ringkasan"
              />
            </v-layout>
          </v-flex>

          <v-flex v-else xs4 md4 lg4 xl4 class="view-surat-left">
            <v-layout column>
              <v-layout row>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.tgl_surat"
                    label="TANGGAL SURAT"
                  />
                </v-flex>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.no"
                    label="NOMOR SURAT"
                  />
                </v-flex>
              </v-layout>
              <v-textarea
                readonly
                label="PERIHAL"
                rows="2"
                no-resize
                v-model="item.perihal"
              />
              <v-textarea
                readonly
                label="TUJUAN"
                placeholder="-"
                rows="2"
                no-resize
                v-model="item.tujuan"
              />
              <v-textarea
                readonly
                label="ORGANISASI"
                placeholder="-"
                rows="2"
                no-resize
                v-model="item.namaBidang"
              />
            </v-layout>
          </v-flex>
          <!-- LAMPIRAN -->
          <v-flex xs8 md8 lg8 xl8 class="view-surat-right">
            <v-layout column fill-height>
              <v-flex>
                <v-tabs v-model="tab" grow>
                  <v-tab>
                    <v-icon>mdi-file-document-outline</v-icon>
                    Arsip
                  </v-tab>
                  <v-tab>
                    <v-icon>mdi-clipboard-check-outline</v-icon>
                    Riwayat Disposisi
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex fill-height>
                <div v-if="tab === 0" class="px-2">
                  <iframe
                    v-if="item.lampiran"
                    :src="item.lampiran"
                    width="100%"
                    height="500px"
                  />
                  <div
                    v-else
                    style="margin-top: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center"
                  >
                    <v-icon
                      style="font-size: 48px; margin-bottom: 20px"
                      color="red"
                      >mdi-file-remove</v-icon
                    >
                    <span>Tidak Ada Arsip</span>
                  </div>
                </div>
                <div v-else style="height: 100%">
                  <v-data-table
                    :headers="disposisiHeaders"
                    :items="item.disposisi"
                    hide-default-footer
                    no-data-text="Belum ada disposisi"
                    show-expand
                    :expanded.sync="expanded"
                    :loading="downloadingDisposisi"
                  >
                    <template v-slot:[`item.disposisi_at`]="{ item }">
                      {{ item.disposisi_at | dateToString }}
                    </template>
                    <template v-slot:[`item.id`]="{ item }">
                      <v-btn
                        rounded
                        small
                        color="primary"
                        text
                        @click.native.stop="downloadDisposisi(item.id)"
                        :disabled="downloadingDisposisi"
                      >
                        <v-icon left>mdi-printer</v-icon>
                        Cetak
                      </v-btn>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <div class="tujuan-disposisi">
                          <span>Diteruskan Kepada:</span>
                          <ul>
                            <li
                              v-for="tujuan in item.tujuan"
                              :key="tujuan.jabatan_id"
                            >
                              {{ tujuan.nama_jabatan }}
                            </li>
                          </ul>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { downloadKartuDisposisi } from '@/services/surat'
export default {
  props: {
    idJenisForm: { type: Number, default: () => 1 },
    item: { type: Object, default: () => null }
  },
  computed: {},
  data() {
    return {
      tab: 0,
      disposisiHeaders: [
        { text: '', value: 'data-table-expand' },
        {
          text: 'Tgl. Disposisi',
          sortable: false,
          value: 'disposisi_at',
          align: 'left'
        },
        {
          text: 'Disposisi Oleh',
          sortable: false,
          value: 'user_name',
          align: 'left'
        },
        { text: 'Catatan', sortable: false, value: 'note', align: 'left' },
        {
          text: 'Kartu Disposisi',
          value: 'id',
          sortable: false,
          align: 'right'
        }
      ],
      disposisiItems: [],
      expanded: [],
      downloadingDisposisi: false
    }
  },
  methods: {
    closeView() {
      this.$emit('close-view-form')
      this.tab = 0
    },
    async downloadDisposisi(id) {
      this.downloadingDisposisi = true
      await downloadKartuDisposisi(id)
      this.downloadingDisposisi = false
    }
  }
}
</script>

<style scoped>
.tujuan-disposisi {
  padding: 1rem 0.5rem;
}
</style>
